import { useFlipperFeatureEnabled } from "source/shared/flipperFeatures"

export function usePcoChatEnabled(): boolean {
  return useFlipperFeatureEnabled("ROLLOUT_pco_chat")
}
